<template>
  <div class="page-size">
    <div class="page-size-label d-inline-block">Items Per Page</div>
    <div class="page-size-field d-inline-block">
      <Field
        type="select"
        name="per_page"
        :options="sizeOptions"
        v-model="current"
        :hideSelectEmptyOption="true"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, default: 10 },
    sizes: { type: Array, default: () => [] }
  },
  data() {
    return {
      sizeOptions: [
        { value: 10, label: "10" },
        { value: 15, label: "15" },
        { value: 20, label: "20" },
        { value: 25, label: "25" },
        { value: 30, label: "30" }
      ],
      current: null
    };
  },
  watch: {
    value(val) {
      this.current = val;
    },
    current(val) {
      this.$emit("input", val);
    }
  },
  created() {
    this.current = this.value;
    if (this.sizes.length > 0) {
      this.sizeOptions = this.sizes;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "bootstrap/scss/_functions";
@import "bootstrap/scss/_variables";
.page-size-label {
  color: gray("600");
  font-size: 0.875rem;
  margin-right: 0.5rem;
}
</style>